export default __webpack_public_path__ + "static/media/face.40490f2d.svg";